import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchModule, type CoverageEnvelope, type ModuleFilters } from '../api/events';

/**
 * Stable query key for the Events → Coverage module envelope. Exported
 * so sibling code (e.g. an invalidator after an ingest) can refer to
 * the same key without re-deriving it.
 */
export function eventsCoverageKey(filters?: ModuleFilters) {
  return ['events', 'coverage', filters ?? {}] as const;
}

/**
 * Fetch the Events → Coverage envelope: per-district tile-cartogram
 * rows + campaign totals + freshness/honesty metadata.
 *
 * Returns the full envelope so consumers can render `<Freshness/>`,
 * `<Denominator/>`, and `<AnomalyChip/>` alongside the cartogram.
 */
export function useEventsCoverage(
  filters?: ModuleFilters,
): UseQueryResult<CoverageEnvelope, Error> {
  return useQuery({
    queryKey: eventsCoverageKey(filters),
    queryFn: ({ signal }) => fetchModule('coverage', filters, { signal }),
    staleTime: 5 * 60 * 1000,
  });
}
